<svg-icon [src]="getCustomerIcon()"
    matTooltip="{{typeName}}"
    [svgClass]="'user-icon'"
    [svgStyle]="{'width.px': width, 'height.px': height}"></svg-icon>